import React from "react";

import { Icon } from "Components/atoms/Icon";
import { Typography } from "Components/atoms/Typography";

import { HeaderContainer } from "./styles";

type FlightDetailsHeaderProps = {
  onClose: () => void;
};

export const FlightCardDetailsHeader: React.FC<FlightDetailsHeaderProps> = ({
  onClose,
}) => (
  <HeaderContainer>
    <Typography variant="label" color="white" uppercase>
      Detalhes da Viagem
    </Typography>
    <button onClick={onClose}>
      <Icon library="md" name="MdKeyboardArrowUp" size="medium" color="white" />
    </button>
  </HeaderContainer>
);
